<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() ? 'Deleted Categories' : 'Categories'"
              ></h3>
              <template v-if="!isDeletePage()">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/Categories/create"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="clearSearch"
                    @keydown.enter="getData"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="clearStatus"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start">Sr No</th>
                      <th class="text-start">Categories</th>
                      <th class="text-start">Add Subcategory</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="categories.length">
                    <tr
                      v-for="(category, i) in categories"
                      :key="`category_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': i === categories.length - 1,
                      }"
                    >
                      <td style="min-width: 85px">{{ i + 1 }}</td>
                      <td>{{ category.name || "N/A" }}</td>
                      <!-- Ensure name is properly displayed -->
                      <td>
                        <v-btn
                          class="mx-2 mb-2"
                          color="primary"
                          small
                          :to="`/categories/${encryptIt(
                            category.id
                          )}/sub-categories`"
                        >
                          Add New
                        </v-btn>
                      </td>
                      <td class="text-right">
                        <template v-if="!isDeletePage()">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                class="mr-2"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="primary"
                                :to="`/categories/${encryptIt(category.id)}`"
                              >
                                <v-icon dark>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Category</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="error"
                                @click="Delete_this(category.id)"
                              >
                                <v-icon dark>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Category</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="success"
                                @click="restoreCategory(category.id)"
                              >
                                <v-icon dark>mdi-delete-restore</v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this Category</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="5" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination
                rounded
                v-model="page"
                :length="paginationLength"
              ></v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "CategoriesPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      categories: [], // Initialize the categories property
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      delete_Category: false,
      is_deleted_Category: false,
      restore_Category: false,
      is_restored_Category: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.search_keyword = this.filter.search_keyword || "";
      this.filter.is_active = this.filter.is_active || "";
      let query = `page=${this.page}&rowsPerPage=10&show_deleted=${this.filter.show_deleted}&is_active=${this.filter.is_active}&search_keyword=${this.filter.search_keyword}`;

      try {
        const response = await axios.get(`categories?${query}`);
        console.log("got:", response.data.data);
        // this.categories = response.data.data.filter(
        //   (category) => category.parent_id == null
        // );
        if (response.data && Array.isArray(response.data.data)) {
          this.categories = response.data.data.filter(
            (category) => category.parent_id == null
          );
        } else {
          console.error(
            "Expected array at response.data.data, but got:",
            response.data.data
          );
          this.categories = []; // or handle appropriately
        }
        console.log("category", this.categories);

        this.count = response.data.count;
        this.paginationLength = Math.ceil(this.count / 10);
      } catch (error) {
        console.error(error);
      }

      this.isLoading = false;
    },
    async Delete_this(id) {
      this.delete_position = true;
      try {
        await axios.post(`/categories/delete/${this.encryptIt(id)}`);
        this.getData();
      } catch (error) {
        console.error(error);
      }
    },
    async restoreCategory(id) {
      this.restore_position = true;
      try {
        await axios.post(`/categories/restore/${this.encryptIt(id)}`);
        this.getData();
      } catch (error) {
        console.error(error);
      }
    },
    clearSearch() {
      this.filter.search_keyword = "";
      this.page = 1;
      this.getData();
    },
    clearStatus() {
      this.filter.is_active = "";
      this.page = 1;
      this.getData();
    },
  },
};
</script>
